// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"9158607c","335":"7ce1b10e"}[chunkId] + ".chunk.js";
};